import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const LinkWithAuth = ({ condition, to, content, className, currentUser }) => {
  const [returnedLink, setReturnedLink] = useState(undefined);
  useEffect(() => {
    if (condition.includes(currentUser.type)) {
      return setReturnedLink(
        <Link to={to} className={className}>
          {content}
        </Link>
      );
    } else {
      return returnedLink;
    }
  }, [currentUser]);
  return <>{returnedLink}</>;
};

LinkWithAuth.propTypes = {
  currentUser: PropTypes.object.isRequired,
  condition: PropTypes.array.isRequired,
  to: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default LinkWithAuth;
